import React,{useEffect} from 'react'
import { NavLink } from 'react-router-dom'
import { useAappContext } from '../context/AppContext'
import moment from 'moment';

const Job = (jobElem) => {
const {getApiHost,ApiHost}=useAappContext();
useEffect(()=>{
getApiHost()
},[0])
  return (
    <>
    <div className="job">
                <div className="image">
                <img src={ApiHost+jobElem.image} alt=""/>
                </div>
                <div className="job-title">
                    <h3>{jobElem.jobTitle}</h3>
                    <NavLink to={'/jobdetails/'+jobElem.id}>
                    <button className="normal">More Info</button>
                    </NavLink>
                </div>
            </div>
    </>
  )
}

const DetailsJob =(jobElims)=>{
  return(
    <>
    <div id="job-details">
                    <div className='job-title'>
                    <p><span>job title:</span>{jobElims.jobTitle}</p>
                    </div>

                    <div className='job-vacanpost'>
                    <p><span>jVacant Position:</span>{jobElims.VacantPosition}</p>
                    </div>

                    <div className='job-role'>
                    <p><span>description of job role:</span> {jobElims.descripitonOfJobRole}</p>
                    </div>

                    <div className='job-salary-benefits'>
                    <p><span>Salary and benefits:</span>{jobElims.salaryAndBenefits}</p>
                    </div>
                    <div className='job-job-location'>
                    <p><span>job location:</span> {jobElims.jobLocation}</p>
                    </div>
                    <div className='job-application-dl'>
                    <p><span>application deadline:</span> {moment(jobElims.applicationEndDate).format('DD - MM - Y')}</p>
                    </div>
                    <div className='job-application-call-to-action'>
                    <p><span>application process:</span> {jobElims.applicationProcess}</p>
                    </div>
                </div>
    </>
  )
}

export {Job,DetailsJob} 